import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Programmazione Infinita',
  description: 'Passi ore ogni settimana a creare allenamenti nuovi, cercare esercizi e organizzare sessioni che mantengano alta la motivazione dei clienti.'
}, {
  emoji: '⚠️',
  title: 'Allenamenti Senza Struttura',
  description: 'A volte hai ottimi esercizi, ma non un sistema chiaro per trasformarli in una lezione professionale e ben organizzata.'
}, {
  emoji: '📚',
  title: 'Informazioni Sparse Ovunque',
  description: 'Salvi idee da Instagram, YouTube e corsi online, ma non hai un metodo unico che ti permetta di programmare in modo rapido ed efficace.'
}, {
  emoji: '😩',
  title: 'Stanchezza Mentale',
  description: 'Tra allenamenti, clienti, programmazione e gestione delle lezioni, hai sempre meno tempo per concentrarti sulla crescita del tuo coaching.'
}];
export function PainSection() {
  return <section className="py-10 px-5 bg-cream" data-id="element-115">
      <h2 className="text-2xl font-heading font-bold text-center text-petrol mb-4" data-id="element-116">
        HAI MAI VISSUTO QUESTA SITUAZIONE?
      </h2>

      <p className="text-sm text-graphite font-body text-center mb-8" data-id="element-117">
        Ami allenare i tuoi clienti, ma la programmazione ti porta via tutto il
        tempo?
        <br data-id="element-118" />
        <br data-id="element-119" />
        <span className="text-sage font-bold" data-id="element-120">
          Se lavori nel Functional Training, probabilmente ti riconosci in una
          di queste situazioni:
        </span>
      </p>

      <div className="flex flex-col gap-4" data-id="element-121">
        {pains.map((pain, i) => <div key={i} className="bg-white p-5 border-l-4 border-petrol" data-id="element-122">
            <div className="text-2xl mb-2" data-id="element-123">{pain.emoji}</div>
            <h3 className="text-base font-bold text-petrol mb-2 font-subheading" data-id="element-124">
              {pain.title}
            </h3>
            <p className="text-graphite text-sm leading-relaxed" data-id="element-125">
              {pain.description}
            </p>
          </div>)}
      </div>
    </section>;
}